import { validateListSearch } from '#/shared/lib/list-search'
import type { AdminNumbersSubtab } from '#/pages/admin/ui/admin-constants'

export function telephonySearch(subtab: AdminNumbersSubtab) {
  return (input: Record<string, unknown>) => ({ subtab, ...validateListSearch(input) })
}
